module.exports = __webpack_public_path__ + "img/sjk.508958af.webp";